export default __webpack_public_path__ + "static/media/vehicle.e19d94faf9c4efca71514e8f1a522927.svg";